export default __webpack_public_path__ + "static/media/arrow-left.b43cd121.svg";